import React from 'react';
import './styles/headerFooter.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} MyBrainOnAI.com. All rights reserved.</p>
    </footer>
  );
};

export default Footer;